module.exports = __webpack_public_path__ + "img/00003.8de1e2ab.webp";